import { FC, useCallback, useEffect } from 'react'
import cn from 'classnames'
import { PlaceholderCell } from 'components/extend/PlaceholderCell'
import ModalItem from 'components/ModalItem'
import { MODAL_IDS, useModal } from 'components/ModalProvider'
import { ModalSimple } from 'components/ModalSimple'
import { formatDate } from 'helpers/dates'
import { useNotifications, useOnMount } from 'hooks'

import { ModalNotificationsProps } from './types'

import s from './ModalNotifications.module.less'

export const ModalNotifications: FC<ModalNotificationsProps> = (props) => {
  const { handleCloseModal, isShow } = props
  const { openModal, closeModal } = useModal()
  const {
    isNotificationLoading,
    getNotification,
    refetchNotification,
    notification,
    notificationNotViewed,
    getAllNotificationsViewed
  } = useNotifications()

  const onClose = useCallback(() => {
    handleCloseModal()
    closeModal(MODAL_IDS.UserNotification)
  }, [closeModal, handleCloseModal])

  useOnMount(() => {
    getNotification('')
  })

  useEffect(() => {
    if (!isShow) {
      return
    }
    getNotification('')
    setTimeout(() => {
      if (!notificationNotViewed) {
        return
      }
      if (notificationNotViewed > 0) {
        getAllNotificationsViewed('')
          .unwrap()
          .then(() => {
            getNotification('')
            refetchNotification()
          })
      }
    }, 1500)
    openModal(MODAL_IDS.UserNotification)
  }, [isShow]) //eslint-disable-line

  return (
    <>
      <ModalItem id={MODAL_IDS.UserNotification}>
        <ModalSimple id={MODAL_IDS.UserNotification} onClose={onClose} title="Уведомления">
          <div className={s.notifications}>
            {/* eslint-disable-next-line */}
            {isNotificationLoading ? (
              [...new Array(3)].map((_, i) => (
                <div key={i}>
                  <PlaceholderCell className={s.skeleton} height={20} />
                  <PlaceholderCell className={s.skeleton} height={24} />
                  <PlaceholderCell className={cn(s.skeleton, s.skeletonLast)} height={80} />
                </div>
              ))
            ) : notification?.length ? (
              notification?.map((el, index) => (
                <div key={index} className={s.notification}>
                  <div className={s.dateBlock}>
                    {!el.isViewed && <div className={s.notifyDot} />}
                    <div className={s.date}>{formatDate(el.createDatetime.toString())}</div>
                  </div>
                  <h2 className={s.title}>{el.title}</h2>
                  {/* TODO убрать такую вставку контента - перейти на коды и справочники */}
                  {/* eslint-disable-next-line react/no-danger */}
                  <div dangerouslySetInnerHTML={{ __html: el.content }} className={s.content} />
                  <div className={s.divider} />
                </div>
              ))
            ) : (
              <div className={s.empty}>Нет новых уведомлений</div>
            )}
          </div>
        </ModalSimple>
      </ModalItem>
    </>
  )
}
